import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import type { Portal } from "./portal";

/**
 * Which portal a platform admin is in: their own organisation or the Humindly admin view.
 * In memory only, for this page load. Every fresh landing at the front door asks again;
 * the sidebar switch changes it directly. The root gate and the sidebar read the same
 * value, so a switch is never one render behind (the bug a stored copy had).
 */
interface PortalState {
  portal: Portal | null;
  setPortal: (p: Portal) => void;
}

const Ctx = createContext<PortalState>({ portal: null, setPortal: () => {} });

export function PortalProvider({ children }: { children: ReactNode }) {
  const [portal, setPortal] = useState<Portal | null>(null);
  const value = useMemo(() => ({ portal, setPortal }), [portal]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const usePortal = () => useContext(Ctx);
